import React from 'react';
import SingleCount from '../../../components/SingleCount/SingleCount';

const HomeCounterArea = () => {
   return (
      <>
         <section className="counter__area pb-100">
            <div className="container">
               <div className="counter__inner white-bg wow fadeInUp" data-wow-delay=".2s">
                  <div className="row">

                     <SingleCount counter={155} title="Trucks" />
                     <SingleCount counter={200} title="Trailers" />
                     <SingleCount counter={265} title="Truck Drivers" />

                  </div>
               </div>
            </div>
         </section>
      </>
   );
};

export default HomeCounterArea;